<div class="row">
    <div class="container brand-heading-container">
        <h1 class="brand-heading"><i class="icon-conversejs"></i>Converse</h1>
        <p class="brand-subtitle">{{{o.version_name}}}</p>
        <p class="brand-subtitle"><a target="_blank" rel="nofollow" href="https://conversejs.org">Open Source</a> XMPP chat client brought to you by <a target="_blank" rel="nofollow" href="https://opkode.com">Opkode</a> </p>
        <p class="brand-subtitle"><a target="_blank" rel="nofollow" href="https://hosted.weblate.org/projects/conversejs/#languages">Translate</a> it into your own language</p>
    </div>
</div>
